import React from 'react';
import { Col, Placeholder, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const ModalLoading = () => {
	const { isDark } = useSelector((state) => state.config);
	const placeholderBg = isDark ? 'dark' : 'light';

	// 生成EventModalMediaContent样式的占位符
	const renderEventModalContentPlaceholder = () => (
		<div className='mt-3' style={{ display: 'flex', alignItems: 'flex-start' }}>
			{/* 图标占位符 */}
			<div style={{ width: '40px', height: '40px', marginRight: '0.75rem', flexShrink: 0 }}>
				<Placeholder as='div' animation='wave'>
					<Placeholder xs={12} bg={placeholderBg} style={{ height: '40px', borderRadius: '50%', width: '40px' }} />
				</Placeholder>
			</div>
			{/* 内容区域 */}
			<div style={{ flex: 1 }}>
				{/* 标题占位符 */}
				<Placeholder as='div' animation='wave' className='mb-2'>
					<Placeholder xs={6} bg={placeholderBg} style={{ height: '16px', borderRadius: '4px' }} />
				</Placeholder>
				{/* 内容占位符 */}
				<Placeholder as='div' animation='wave' className='mb-1'>
					<Placeholder xs={8} bg={placeholderBg} style={{ height: '12px', borderRadius: '4px' }} />
				</Placeholder>
				<Placeholder as='div' animation='wave' className='mb-1'>
					<Placeholder xs={10} bg={placeholderBg} style={{ height: '12px', borderRadius: '4px' }} />
				</Placeholder>
				<Placeholder as='div' animation='wave'>
					<Placeholder xs={7} bg={placeholderBg} style={{ height: '12px', borderRadius: '4px' }} />
				</Placeholder>
			</div>
		</div>
	);

	// 生成较大的内容区域占位符（用于物流状态、支付状态等）
	const renderLargeContentPlaceholder = () => (
		<div className='mt-3' style={{ display: 'flex', alignItems: 'flex-start' }}>
			{/* 图标占位符 */}
			<div style={{ width: '40px', height: '40px', marginRight: '0.75rem', flexShrink: 0 }}>
				<Placeholder as='div' animation='wave'>
					<Placeholder xs={12} bg={placeholderBg} style={{ height: '40px', borderRadius: '50%', width: '40px' }} />
				</Placeholder>
			</div>
			{/* 内容区域 */}
			<div style={{ flex: 1 }}>
				{/* 标题占位符 */}
				<Placeholder as='div' animation='wave' className='mb-2'>
					<Placeholder xs={5} bg={placeholderBg} style={{ height: '16px', borderRadius: '4px' }} />
				</Placeholder>
				{/* 较大的内容卡片 */}
				<Placeholder as='div' animation='wave' className='mb-2'>
					<Placeholder xs={12} bg={placeholderBg} style={{ height: '80px', borderRadius: '6px' }} />
				</Placeholder>
				<Placeholder as='div' animation='wave' className='mb-2'>
					<Placeholder xs={12} bg={placeholderBg} style={{ height: '60px', borderRadius: '6px' }} />
				</Placeholder>
			</div>
		</div>
	);

	// 生成销售绩效占位符（较大的卡片）
	const renderPerformancePlaceholder = () => (
		<div className='mt-3' style={{ display: 'flex', alignItems: 'flex-start' }}>
			{/* 图标占位符 */}
			<div style={{ width: '40px', height: '40px', marginRight: '0.75rem', flexShrink: 0 }}>
				<Placeholder as='div' animation='wave'>
					<Placeholder xs={12} bg={placeholderBg} style={{ height: '40px', borderRadius: '50%', width: '40px' }} />
				</Placeholder>
			</div>
			{/* 内容区域 */}
			<div style={{ flex: 1 }}>
				{/* 标题占位符 */}
				<Placeholder as='div' animation='wave' className='mb-2'>
					<Placeholder xs={4} bg={placeholderBg} style={{ height: '16px', borderRadius: '4px' }} />
				</Placeholder>
				{/* 图表/卡片占位符 */}
				<Placeholder as='div' animation='wave' className='mb-2'>
					<Placeholder xs={12} bg={placeholderBg} style={{ height: '120px', borderRadius: '6px' }} />
				</Placeholder>
				{/* 信息行占位符 */}
				{[...Array(4)].map((_, index) => (
					<Placeholder key={index} as='div' animation='wave' className='mb-1'>
						<Placeholder xs={12} bg={placeholderBg} style={{ height: '20px', borderRadius: '4px' }} />
					</Placeholder>
				))}
			</div>
		</div>
	);

	// 产品列表占位符
	const ProductListDetailPlaceholder = ({ placeholderBg }) => (
		<Col>
			<Placeholder as='div' animation='wave' className='mb-3'>
				<Placeholder xs={3} bg={placeholderBg} style={{ height: '18px', borderRadius: '4px' }} />
			</Placeholder>
			{[...Array(3)].map((_, index) => (
				<Placeholder key={index} as='div' animation='wave' className='mb-2'>
					<Placeholder xs={12} bg={placeholderBg} style={{ height: '50px', borderRadius: '6px' }} />
				</Placeholder>
			))}
		</Col>
	);

	// 附件列表占位符
	const OrderAttachmentListPlaceholder = ({ placeholderBg }) => (
		<Col>
			<Placeholder as='div' animation='wave' className='mb-3'>
				<Placeholder xs={3} bg={placeholderBg} style={{ height: '18px', borderRadius: '4px' }} />
			</Placeholder>
			{[...Array(2)].map((_, index) => (
				<Placeholder key={index} as='div' animation='wave' className='mb-2'>
					<Placeholder xs={12} bg={placeholderBg} style={{ height: '40px', borderRadius: '6px' }} />
				</Placeholder>
			))}
		</Col>
	);

	return (
		<div style={{ padding: '0.5rem 0' }}>
			<Row>
				{/* 左侧主内容区 - sm={8} */}
				<Col sm={8}>
					{/* 第一行：客户详情+订单备注 和 物流状态 */}
					<Row>
						<Col>
							{/* 客户详情 */}
							{renderEventModalContentPlaceholder()}
							{/* 订单备注 */}
							{renderEventModalContentPlaceholder()}
						</Col>
						<Col>
							{/* 物流状态 */}
							{renderLargeContentPlaceholder()}
						</Col>
					</Row>
					<div className='mt-3'>
						<ProductListDetailPlaceholder placeholderBg={placeholderBg} />
					</div>
				</Col>

				{/* 右侧边栏 - sm={4} */}
				<Col sm={4}>
					{/* 支付详情（在Row中） */}
					<Row>
						<Col>{renderEventModalContentPlaceholder()}</Col>
					</Row>
					{/* 支付状态 */}
					{renderLargeContentPlaceholder()}
					{/* 销售绩效 */}
					{renderPerformancePlaceholder()}
				</Col>
			</Row>
			<Row className='mt-3'>
				<OrderAttachmentListPlaceholder placeholderBg={placeholderBg} />
			</Row>
		</div>
	);
};

export default ModalLoading;
